// @file Pinia store to manage the zoom level of the whiteboard

import { isTouchScreen } from '@@/bits/browser'
import { unboundedWatch } from '@@/bits/vue'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { defineStore } from 'pinia'
import { computed, readonly, ref } from 'vue'

export const useWhiteboardZoomLevelStore = defineStore('whiteboardZoomLevel', () => {
  const surfaceContainerSizeStore = useSurfaceContainerSizeStore()

  const zoomLevel = ref(0)

  const minZoomLevel = ref(Number.MAX_SAFE_INTEGER)

  // Store the smallest zoom level that has been set, ignoring zero (zoom
  // level can't possibly be zero).
  void unboundedWatch(
    zoomLevel,
    (newZoomLevel) => {
      if (newZoomLevel > 0) {
        minZoomLevel.value = Math.min(minZoomLevel.value, newZoomLevel)
      }
    },
    { immediate: true },
  )

  const isAllowingZooming = computed(() => {
    if (
      (surfaceContainerSizeStore.isLandscapePhone || surfaceContainerSizeStore.isLandscapeTablet) &&
      isTouchScreen()
    ) {
      return true
    }
    return !surfaceContainerSizeStore.isContainerBiggerThanTabletLandscape
  })

  return {
    zoomLevel,
    minZoomLevel: readonly(minZoomLevel),
    isAllowingZooming,
  }
})
